

<div style="border-top:1px solid #fff;" class="row pl-1" >
<div class="col-9 p-0" style="height: calc(100% - 30px) !important;">

  <div class="scheduler-navigator-container">
    <div class="navigator" style="border-right: 1px solid #ddd;">
 
      
        <div>
          <div *ngIf="calmod=='calendar'" class="contact-buttons">
            <button class="contact-btn phone-btn" 
                    [class.disabled]="!item?.root_order?.person?.phone"
                    [disabled]="!item?.root_order?.person?.phone"
                    (click)="item?.root_order?.person?.phone ? call(item.root_order.person.phone) : null" 
                    title="Festnetz anrufen">
              <mat-icon>local_phone</mat-icon>
            </button>
            <button class="contact-btn mobile-btn" 
                    [class.disabled]="!item?.root_order?.person?.mobile"
                    [disabled]="!item?.root_order?.person?.mobile"
                    (click)="item?.root_order?.person?.mobile ? call(item.root_order.person.mobile) : null" 
                    title="Mobil anrufen">
              <mat-icon>phone_iphone</mat-icon>
            </button>
            <button class="contact-btn email-btn" 
                    [class.disabled]="!item?.root_order?.person?.email"
                    [disabled]="!item?.root_order?.person?.email"
                    (click)="item?.root_order?.person?.email ? openMail(item?.id, item?.root_order?.person?.email) : null"
                    title="E-Mail senden">
              <mat-icon>email</mat-icon>
            </button>
          </div>
          <daypilot-navigator class="w-full" [config]="navigatorConfig" (dateChange)="onNavigatorDateChange($event)"  (eventRender)="eventRender($event)"></daypilot-navigator>

          <!-- Abstand zwischen Navigator und Drag Object -->
          <div style="margin-top: 2px;"></div>

          <div *ngIf="calmod=='calendar'">
          <ng-container style="padding: 12px;" class="cursor-pointer">
            <div *ngIf="!loading"
                 (click)="selectedSecMenuIndex=1"
                 (dragstart)="onDragStart($event)"
                 [attr.draggable]="true"
                 [draggableToScheduler]="getDraggableData()"
                 class="dispo-card">
              <div class="dispo-card-header" [attr.draggable]="true">
                <span class="dispo-color-dot" [style.background-color]="dispoMode?.color"></span>
                <strong class="dispo-title">{{ dispoMode?.name || 'Disposition' }}</strong>
                <span class="dispo-header-spacer"></span>
                <button mat-icon-button class="dispo-header-action" [matMenuTriggerFor]="dispoTypeMenu" aria-label="Terminart wählen" (click)="$event.stopPropagation()">
                  <mat-icon>expand_more</mat-icon>
                </button>
              </div>
              <div class="dispo-card-body" [attr.draggable]="true">
                <div class="dispo-row">
                  <strong>{{item?.root_order?.person?.first_name}} {{item?.root_order?.person?.last_name}}</strong>
                </div>
                <div class="dispo-row">
                  <span class="dispo-address-line"
                        [title]="(item?.root_order?.person?.street || '') + ', ' + (item?.root_order?.person?.postal_code || '') + ' ' + (item?.root_order?.person?.place || '')">
                    {{item?.root_order?.person?.street}}, {{item?.root_order?.person?.postal_code}} {{item?.root_order?.person?.place}}
                  </span>
                </div>
                <div class="dispo-meta">
                  <span *ngIf="!isRekla(item)">{{item?.amount_assembly_units}}ME</span>
                  <span *ngIf="!isRekla(item)">•</span>
                  <span *ngIf="!isRekla(item)">{{item?.duration}}min</span>
                  <span *ngIf="isRekla(item) && getReklaSelectedTypeLabel(item)" class="dispo-rekla-type">
                    <span>{{getReklaSelectedTypeLabel(item)}}</span>
                    <span *ngIf="getReklaSelectedHours(item)">: {{getReklaSelectedHours(item)}}</span>
                  </span>
                  <span class="dispo-spacer"></span>
                  <span class="dispo-badge">{{item?.order_type?.label}}</span>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Menü zur Auswahl der Terminart -->
          <mat-menu #dispoTypeMenu="matMenu">
            <button mat-menu-item *ngFor="let option of teamOrderTypes" (click)="dispoMode = option">
              <mat-icon *ngIf="dispoMode?.id === option?.id">check</mat-icon>
              <span>{{ option?.name }}</span>
            </button>
          </mat-menu>
        
          <!--div class="p-0.5">  
              <pagination-controls (pageChange)="p = $event"></pagination-controls>
              <table class="w-full">
                <thead>
                  <tr class="tab_at_cat">
                    <td>Datum</td>
                    <td>Tag</td>
                    <td><span class="font-bold">Team</span></td>
                    <td>Zeit</td>
                    <td>AL</td>
                  </tr>
                </thead>
                
                <ng-container class="table-scroll">
                  <tbody>
                    
                    <tr colspan="5" style="border-bottom: 1px solid #ccc; text-align: center;">
                      <td colspan="5" class="cursor-pointer" (click)="prevPage()">
                        <i class="la la-arrow-up cursor-pointer" title="Zurück"></i>
                      </td>
                    </tr>
                    
                    <ng-container *ngFor="let prev of prevList | paginate: { itemsPerPage: 6, currentPage: p }">
                      <tr *ngIf="prev.team_absence == 'Present'" 
                          [ngClass]="{'bg-red-100': item?.duration > prev.time_left}" 
                          class="cursor-pointer" 
                          (mouseover)="highlightEvent(prev)" 
                          (mouseout)="clearHighlight(prev)" 
                          (click)="dispose_from_prev(item, prev)">
                        <td class="">{{prev.prev_start | date: 'dd.MM.yy'}}</td>
                        <td>{{ translateWeekday(prev.prev_start | date: 'EEE') }}</td>
                        <td><span class="font-bold w-64 truncate" title="{{prev.team_base.label}}"><div class="truncate w-auto max-w-xs">
                          {{ prev.team_base.label.length > 10 ? (prev.team_base.label | slice: 0:10) + '...' : prev.team_base.label }}
                        </div></span></td>
                        <td>{{prev.prev_start_time ? (prev.prev_start_time | date: 'HH:mm') : '-'}}</td>
                        <td>{{convertDurationToHoursAndMinutes(prev.time_left)}}</td> 
                      </tr>
                    </ng-container>
                    
                  
                    <tr colspan="5" style="border-bottom: 1px solid #ccc; text-align: center;">
                      <td colspan="5" class="cursor-pointer" (click)="nextPage()">
                        <i class="la la-arrow-down cursor-pointer" title="Weiter"></i>
                      </td>
                    </tr>
                  </tbody>
                </ng-container>
              </table>
              
            
          </div-->
          </div>

          <div *ngIf="calmod == 'scheduler'">
            <div class="px-1">
            <label><small>Teamfilter</small></label>
            <input type="text" [(ngModel)]="resourceSearch" (input)="filterResources()" placeholder="Ressourcen filtern..." class="form-control resource-search">
          </div>
          <hr>
          <div class="px-1">
            <label><small>Auftragssuche</small></label>
            <input type="text" [(ngModel)]="orderSearch" (input)="searchOrder()" placeholder="Auftrag suchen..." class="form-control resource-search">
          </div>
          </div>
          
              <!-- Vorgeschlagene Termine (4x4 Raster) -->
         <div class="suggested-section" *ngIf="calmod=='calendar'">
           <div class="suggested-header">
            
             <div class="suggested-team-selector">
               <button mat-icon-button class="team-dropdown-btn" [matMenuTriggerFor]="teamMenu" aria-label="Team auswählen">
                 <span class="team-dropdown-text">{{ getSelectedTeamName() }}</span>
                 <mat-icon>expand_more</mat-icon>
               </button>
               <mat-menu #teamMenu="matMenu">
                 <button mat-menu-item (click)="selectSuggestedTeam('')">
                   <mat-icon *ngIf="!selectedSuggestedTeam">check</mat-icon>
                   <span>Alle Teams</span>
                 </button>
                 <button mat-menu-item *ngFor="let team of availableTeams" (click)="selectSuggestedTeam(team.id)">
                   <mat-icon *ngIf="selectedSuggestedTeam === team.id">check</mat-icon>
                   <span>{{ team.label }}</span>
                 </button>
               </mat-menu>
             </div>
           </div>
           <div class="suggested-grid" style="grid-template-columns: repeat(3, 1fr); overflow-y: auto; max-height: 100%;">
             <button class="suggestion-cell" *ngFor="let suggestion of suggestedAppointments; let idx = index" 
                     (click)="selectSuggestedAppointment(suggestion)" 
                     [title]="suggestion.fullDate">
               <div class="suggestion-team">{{ suggestion.teamName }}</div>
               <div class="suggestion-title">{{ suggestion.date | date:'dd.MM' }}</div>
               <div class="suggestion-meta">{{ suggestion.time }}</div>
             </button>
           </div>
         </div>

          <div>

          </div>

          <!--div class="form-group">
            <small>Kunde</small><br>
            <select [(ngModel)]="filterCustomer" (ngModelChange)="changeCustomer()" class="form-control" style="padding-left: 10px;">
              <option [ngValue]=null>alle</option>
              <option *ngFor="let customer of filterCustomerList" [ngValue]="customer.id">{{customer.company}}</option>
            </select>
          </div>
      
            <div class="form-group">
              <small>Standort</small><br>
              <ng-select 
                [(ngModel)]="filterCustomerBranch" 
                [items]="filterCustomerBranchList" 
                bindLabel="title" 
                bindValue="id"
                [multiple]="true"
                (ngModelChange)="changePerPage()"
                >
              </ng-select>
            </div-->

        </div>

    
    </div>

    <div class="flexible-width w-full column-layout">
      <!-- Moderne Toolbar ohne Navbar -->
      <div class="modern-toolbar">
        <!-- Linke Seite - Hauptaktionen -->
        <div class="toolbar-left">
          <button class="toolbar-btn primary" [matMenuTriggerFor]="menu">
            <mat-icon>add</mat-icon>
            <span>Neu</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="gotoTeamDetails(null)">
              <mat-icon>group</mat-icon>
              <span>Team</span>
            </button>
          </mat-menu>

          <button class="toolbar-btn" [matMenuTriggerFor]="export">
            <mat-icon>download</mat-icon>
            <span>Export</span>
          </button>
          <mat-menu #export="matMenu">
            <button mat-menu-item (click)="onSelect('Option 1')">
              <mat-icon>picture_as_pdf</mat-icon>
              <span>PDF</span>
            </button>
            <button mat-menu-item (click)="onSelect('Option 3')">
              <mat-icon>table_chart</mat-icon>
              <span>CSV</span>
            </button>
            <button mat-menu-item (click)="onSelect('Option 3')">
              <mat-icon>grid_on</mat-icon>
              <span>XLSX</span>
            </button>
          </mat-menu>

          <button class="toolbar-btn" [matMenuTriggerFor]="static">
            <mat-icon>analytics</mat-icon>
            <span>Auswertungen</span>
          </button>
          <mat-menu #static="matMenu">
            <button mat-menu-item (click)="genKitchenDeliveryList()">
              <mat-icon>local_shipping</mat-icon>
              <span>Küchenlieferungen CSV</span>
            </button>
            <button mat-menu-item (click)="genKitchenAssemblyList()">
              <mat-icon>build</mat-icon>
              <span>Küchenmontagen CSV</span>
            </button>
          </mat-menu>
        </div>

        <!-- Rechte Seite - Ansichtsoptionen -->
        <div class="toolbar-right">
          <button class="toolbar-btn" [matMenuTriggerFor]="mode">
            <mat-icon>view_module</mat-icon>
            <span>Modus</span>
          </button>
          <mat-menu #mode="matMenu">
            <button mat-menu-item (click)="switchMiddleSlot('calendar')">
              <mat-icon>calendar_today</mat-icon>
              <span>Kalender</span>
            </button>
            <button mat-menu-item (click)="switchMiddleSlot('teamList')">
              <mat-icon>list</mat-icon>
              <span>Team Liste</span>
            </button>
            <button mat-menu-item (click)="switchMiddleSlot('map')">
              <mat-icon>map</mat-icon>
              <span>Karte</span>
            </button>
          </mat-menu>

          <button class="toolbar-btn" [matMenuTriggerFor]="view">
            <mat-icon>view_list</mat-icon>
            <span>Ansicht</span>
          </button>
          <mat-menu #view="matMenu">
            <button *ngFor="let cv of calendarViews" mat-menu-item (click)="selectCalendarView(cv.id)">
              <mat-icon>view_week</mat-icon>
              <span>{{ cv.title }}</span>
            </button>
          </mat-menu>
        </div>
      </div>

       <!-- Map -->
      <div *ngIf="middleSlot == 'map' && item" style="height: 100%; width: 100%;">
     
          <!--a class="p-0.5 border-2 border-black" (click)="mapActionCenterOrder()">CO</a>
          <a class="p-0.5 border-2 border-black" (click)="mapActionSwitchViewMode()">SVM</a>
          <a class="p-0.5 border-2 border-black" (click)="mapActionSwitch3D2D()">VM</a>
          <a class="p-0.5 border-2 border-black" (click)="mapActionRotate()">Rotate</a-->
        <agm-map style="height: calc(100); width: 100%;" #map [latitude]="item?.lat" [longitude]="item?.lng" [zoom]="zoomLevel" [mapTypeId]="mapTypeId" [tilt]="tilt">
        <agm-direction *ngIf="selectedWaypoints?.length" 
          [origin]="getOrigin()"
          [destination]="getDestination()"
          [waypoints]="getWaypoints()"
          [optimizeWaypoints]="true" >
      </agm-direction>
      <agm-marker *ngFor="let waypoint of selectedWaypoints"
      [latitude]="waypoint.lat"
      [longitude]="waypoint.lng"
      [iconUrl]="'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'"
      [iconSize]="{ width: 10, height: 10 }">
      </agm-marker>
          <!--agm-circle 
            [latitude]="map_customer_branch?.lat"
            [longitude]="map_customer_branch?.lng"
            [radius]="40000"
            [strokeColor]="'#000000'"
            [strokeOpacity]="1"
            [strokeWeight]="1"
            [fillColor]="'#FFFF00'"
            [fillOpacity]="0.3"
            [editable]="false"
            [draggable]="false">
          </agm-circle-->
          <agm-marker *ngIf="!item?.disposed" [latitude]="item?.lat" 
            [longitude]="item?.lng" 
            [iconUrl]="getSvgCircularMarker('A', 'DSP', 'black', 'white', 'black')"
            [iconSize]="{ width: 10, height: 10 }"
            [markerClickable]="true"
            (markerClick)="mapGetOrderDetails(mto)"
        
            >
          </agm-marker>    
          <agm-marker *ngFor="let mto of mapOrders?.undisposed"
            [latitude]="mto?.lat"
            [longitude]="mto?.lng"
            [clickable]="true"
            [iconUrl]="getSvgMarker(mto?.last_name,mto?.order_number, 'green', 'green', 'white')"
            [iconSize]="{ width: 10, height: 10 }"
            [markerClickable]="true"
            (markerClick)="mapGetOrderDetails(mto)"
            
            >
            <!--agm-info-window>
              <div>
                <p><span class="font-bold">Termin am:</span> <br><span class="p-0.5 bg-green-500 text-white">{{ mto?.order.start | date: 'dd.MM.yyyy' }}, {{ mto?.order.start | date: 'HH:mm' }} - {{ mto?.order.end | date: 'HH:mm' }}Uhr</span><br><span class="badge badge-secondary">{{mto.order.order_type?.label}} ({{mto.order.order_number}})</span><span class="ml-0.5 badge badge-secondary">{{ mto?.order.duration }}</span><br><span class="font-bold">{{ mto?.order.last_name }} {{ mto?.order.first_name }}</span><br>
                  {{mto?.order.street}}, {{mto?.order.postal_code}} {{mto?.order.place}}</p>
              </div>
            </agm-info-window-->
          </agm-marker>

          <agm-marker *ngFor="let mto of mapOrders?.disposed"
            [latitude]="mto?.lat"
            [longitude]="mto?.lng"
            [clickable]="true"
            [iconUrl]="getSvgMarker(mto?.last_name,mto?.order_number, 'blue', 'blue', 'white')"
            [iconSize]="{ width: 10, height: 10 }"
            [markerClickable]="true"
            (markerClick)="mapGetOrderDetails(mto)"
            >
          </agm-marker>
          <agm-marker [latitude]="map_customer_branch?.lat" 
            [longitude]="map_customer_branch?.lng" 
            [iconUrl]="getSvgCircularMarker(map_customer_branch?.short,2, 'orange', 'white', 'black')"
            [iconSize]="{ width: 10, height: 10 }">
          </agm-marker> 


          <!--agm-marker *ngFor="let order of map_undisposed_orders"
            [latitude]="order?.lat"
            [longitude]="order?.lng"
            [iconUrl]="getMarker(order)">
            <agm-info-window>
              <div>
                <p><span class="badge badge-secondary">{{order.order_type?.label}} ({{order.order_number}})</span><span class="ml-0.5 badge badge-secondary">{{ order?.duration }}</span><br><span class="font-bold">{{ order?.last_name }} {{ order?.first_name }}</span><br>
                  {{order?.street}}, {{order?.postal_code}} {{order?.place}}</p>
                  <a class="btn btn-outline-secondary" (click)="navigateToOrder(order)">zum Auftrag</a>
              </div>
            </agm-info-window>
          </agm-marker-->
        </agm-map>
      </div>
      <!-- DayPilot Scheduler -->
      <daypilot-scheduler *ngIf="middleSlot == 'calendar'" 
                          (viewChange)="onViewChange($event)" 
                          [config]="config" 
                          [events]="events" 
                          #scheduler 
                          class="scheduler">
      </daypilot-scheduler>

      <!-- TeamList -->
      <div class="table-container w-full" *ngIf="middleSlot == 'teamList'">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <mat-form-field style="flex: 1; max-width: 200px; padding: 5px">
            <mat-label>Suche</mat-label>
            <input matInput (keyup)="applyTeamFilter($event)" placeholder="Suchbegriff" #input>
          </mat-form-field>
        
          <mat-paginator [pageSizeOptions]="[10, 50, 100, 250]" showFirstLastButtons aria-label="Select page of periodic elements">
          </mat-paginator>
        </div>

        <table mat-table [dataSource]="dataSource" style="border-top: 1px solid #ccc" matSort (matSortChange)="announceSortChange($event)" class="w-full team-table">

          <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->
        
          <!-- Position Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by id">ID</th>
            <td mat-cell *matCellDef="let element"> <strong>{{element?.id}}</strong></td>
          </ng-container>

          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by label"> Bezeichnung</th>
            <td mat-cell *matCellDef="let element"> <strong>{{element?.label}}</strong></td>
          </ng-container>
        
          <!-- Name Column -->
          <ng-container matColumnDef="identity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by identity"> Identifikation </th>
            <td mat-cell *matCellDef="let element"> {{element?.identity}} </td>
          </ng-container>
        
          <!-- Weight Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by type"> Typ </th>
            <td mat-cell *matCellDef="let element"> {{element?.type}} </td>
          </ng-container>
        
          <!-- Symbol Column -->
          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by company"> Firma </th>
            <td mat-cell *matCellDef="let element"> {{element?.company?.company_name || '-'}} </td>
          </ng-container>

          <ng-container matColumnDef="default_start">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by default_start"> Startzeit </th>
            <td mat-cell *matCellDef="let element"> {{element.default_start}} </td>
          </ng-container>

          <ng-container matColumnDef="default_end">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by default_end"> Startzeit </th>
            <td mat-cell *matCellDef="let element"> {{element.default_end}} </td>
          </ng-container>

          <ng-container matColumnDef="cal_calendar">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by cal_calendar"> GroupOfficeTeam </th>
            <td mat-cell *matCellDef="let element"><span *ngIf="element.cal_calendar" class="badge badge-success"> {{element.cal_calendar?.name}} ( {{element.cal_calendar?.id}})</span></td>
          </ng-container>

          <ng-container matColumnDef="deleted_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by deleted_at"> inaktiv</th>
            <td mat-cell *matCellDef="let element"><span *ngIf="element.deleted_at">{{element.deleted_at ? 'inaktiv' : 'aktiv'}} </span></td>
          </ng-container>

          <ng-container matColumnDef="killable">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by killable"> löschen</th>
            <td mat-cell *matCellDef="let element"><span *ngIf="element.killable">{{element.killable ? 'löschen!' : 'nein'}} </span></td>
          </ng-container>



          <ng-container matColumnDef="action">
            <th class="text-left" mat-header-cell *matHeaderCellDef> Aktion </th>
            <td mat-cell *matCellDef="let element"> </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{
            'inactive-row': row.deleted_at,
            'killable-row': row.killable
          }"
          class="cursor-pointer"
          (click)="gotoTeamDetails(row.id)"
          [class.selected]="row.id == selectedRowIndex"
        >
        </tr>
        
        </table>
        </div>


    </div>
    
  </div>
</div>

<div class="col-3 p-0"  style="border-left: 1px solid #ddd;" style="height: calc(100% - 80px) !important;">
  <mat-tab-group #tabGroup [(selectedIndex)]="selectedSecMenuIndex" id="nav_tab" mat-stretch-tabs="true" (selectedIndexChange)="onTabChange($event)">
    <mat-tab style="border-left: 1px solid #ddd;" label="Sektierter Auftrag"></mat-tab>
    <mat-tab style="border-left: 1px solid #ddd;" label="Dispo-Auftrag"></mat-tab>
    <mat-tab style="border-left: 1px solid #ddd;" label="Rollkarte"></mat-tab>
  </mat-tab-group>


  <!--div *ngIf="this.calmod=='scheduler'" class=""-->
  <div *ngIf="this.calmod=='scheduler' || this.calmod=='calendar'" class="">
    <div 
      class="scrollable-div p-0.5"
      *ngIf="selectedSecMenuIndex == 0 && order"
      style="max-height: 65vh; overflow-y: auto;"
    >
        <table class="w-full p-0.5" style="font-size: 12px">
          <tbody style="border-bottom: 1px solid #aaa">
          <tr><td colspan="2" class="text-center bg-gray-600 text-white">Kunde</td></tr>
          <tr><td class="font-bold">Vorname:</td><td>{{order?.root_order?.person?.first_name}}</td></tr>
          <tr><td class="font-bold">Nachname:</td><td>{{order?.root_order?.person?.last_name}}</td></tr>
          <tr><td class="font-bold">Adresse:</td><td>{{order?.root_order?.person?.street}}<br>{{order?.root_order?.person?.postal_code}} {{order?.root_order?.person?.place}}</td></tr>
          <tr>
            <td class="font-bold">Email:</td>
            <td (click)="sendEmail(order?.id, order?.root_order?.person?.email)" style="cursor: pointer;">
              {{order?.root_order?.person?.email}}
            </td>
          </tr>
          <tr>
            <td class="font-bold">Mobile:</td>
            <td (click)="confirmCall(order?.root_order?.person?.mobile, order?.root_order?.person?.first_name, order?.root_order?.person?.last_name)" style="cursor: pointer;">
              {{order?.root_order?.person?.mobile}}
            </td>
          </tr>
          <tr>
            <td class="font-bold">Tel:</td>
            <td (click)="confirmCall(order?.root_order?.person?.phone, order?.root_order?.person?.first_name, order?.root_order?.person?.last_name)" style="cursor: pointer;">
              {{order?.root_order?.person?.phone}}
            </td>
          </tr>
          </tbody>
         
          <tbody>
            <tr><td colspan="2" class="text-center bg-gray-600 text-white">Auftragsdaten</td></tr>
            <tr><td class="font-bold">Auftragsnummer:</td><td>{{order?.order_number}}</td></tr>
            <tr><td class="font-bold">Auftragstyp:</td><td>{{order?.order_type.label}}</td></tr>
            <tr><td class="font-bold">Zahler:</td><td>{{getPayerName(order)}}</td></tr>
            <tr><td class="font-bold">Umsatz</td><td>{{order?.rev_total}} EUR</td></tr>
            <tr><td class="font-bold">Dauer:</td><td>{{this.helper.convertMinutesToHours(order?.duration)}}</td></tr>
            <tr>
              <td class="font-bold">Klassifizierung:</td>
              <td>
                <ng-container *ngIf="order?.skill?.length > 0; else noSkills">
                  <span *ngFor="let skill of order.skill">
                    <label class="badge ml-0.5" [style.background-color]="skill.color ? skill.color : '#000000'">
                      {{ skill.title }}
                    </label>
                  </span>
                </ng-container>
                <ng-template #noSkills>
                  <span>Keine Klassifizierung vorhanden</span>
                </ng-template>
              </td>
            </tr>           
            </tbody>

            <tbody>
              <tr><td colspan="2" class="text-center bg-gray-600 text-white">Termine</td></tr>
              <tr *ngIf="order?.status || order?.status_id">
                <td colspan="2" class="p-1">
                  <span 
                    class="event-status-badge-full event-status-badge-clickable"
                    [style.backgroundColor]="(order?.status?.color) || '#6c757d'"
                    (click)="openStatusChangeModalForOrder(order)"
                    title="Status ändern (klicken)">
                    {{ order?.status?.label || order?.status?.name || 'Status ' + order?.status_id }}
                  </span>
                </td>
              </tr>
              <tr *ngFor="let to of order?.team_order">
                <td colspan="2" class="font-bold" style="border-bottom: 1px solid #aaa">
                  {{ to?.start ? (to?.start | date: 'dd.MM.yyyy, HH:mm') + ' - ' + (to?.end | date: 'HH:mm') : '-' }} 
                  | {{ to?.team_base?.label || '-' }} 
                  | {{ to?.team_order_type?.name || '-' }}<br>

                  <span *ngIf="to.comment" class="badge bg-black text-white">{{to?.comment}}</span>
                
                </td>
               
              </tr>           
            </tbody>
            <tbody>
              <tr><td colspan="2" class="text-center bg-gray-600 text-white">Notizen</td></tr>

              <tr *ngFor="let note of order?.notes">
                <td colspan="2" class="font-bold" style="border-bottom: 1px solid #aaa">
                  {{note.created_at | date: 'dd.MM.yyyy'}},  {{note.description}}<br>
                </td>
               
              </tr>           
            </tbody>
            <tbody>
              <tr><td colspan="2" class="text-center bg-gray-600 text-white">Dokumente</td></tr>
              <tr>
                <td colspan="2" style="padding: 8px;">
                  <!-- Dokumente als Thumbnails (wie bei order-overview) -->
                  <div *ngIf="getAllDocuments().length > 0" style="font-size: 11px;">
                    <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(45px, 1fr)); gap: 5px;">
                      <!-- PDFs und Videos (alle anzeigen) -->
                      <ng-container *ngFor="let doc of getAllDocumentsSorted(); let i = index">
                        <div *ngIf="isPdf(doc) || isVideo(doc)" 
                             class="document-thumbnail" 
                             style="position: relative; cursor: pointer; border: 1px solid #dee2e6; border-radius: 4px; overflow: hidden; aspect-ratio: 1; background-color: #f8f9fa;"
                             (click)="openDocument(doc)"
                             [title]="doc.name">
                          <!-- PDF -->
                          <div *ngIf="isPdf(doc)" 
                               style="width: 100%; height: 100%; position: relative; display: flex; align-items: center; justify-content: center; background-color: #dc3545;">
                            <!-- PDF oben links -->
                            <span style="position: absolute; top: 4px; left: 4px; color: white; font-weight: normal; font-size: 10px; line-height: 1;">
                              PDF
                            </span>
                            <!-- document_type.short unten links mit Abstand -->
                            <span *ngIf="doc.document_type?.short" style="position: absolute; bottom: 4px; left: 4px; color: white; font-weight: bold; font-size: 12px; line-height: 1;">
                              {{ doc.document_type.short }}
                            </span>
                          </div>
                          <!-- Video-Icon -->
                          <div *ngIf="isVideo(doc)" 
                               style="width: 100%; height: 100%; position: relative; display: flex; align-items: center; justify-content: center; background-color: #6c757d;">
                            <!-- Play Button SVG -->
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M10 8L16 12L10 16V8Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                      </ng-container>
                      
                      <!-- Alle Bilder anzeigen -->
                      <ng-container *ngFor="let doc of getImageVideoDocuments(); let i = index">
                        <div *ngIf="isImage(doc)" 
                             class="document-thumbnail" 
                             style="position: relative; cursor: pointer; border: 1px solid #dee2e6; border-radius: 4px; overflow: hidden; aspect-ratio: 1; background-color: #e9ecef;"
                             (click)="openMediaInLightbox(doc, i)"
                             [title]="doc.name">
                          <img [src]="getThumbnailSrc(doc)" 
                               [alt]="doc.name"
                               style="display: block; width: 100%; height: 100%; object-fit: cover; opacity: 0; transition: opacity 0.3s ease-in-out;"
                               (error)="onOrderImageError($event, doc)"
                               (load)="onImageLoad($event)"
                               (loadstart)="onImageLoadStart($event)">
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  
                  <!-- Nachricht wenn keine Dokumente vorhanden -->
                  <div *ngIf="getAllDocuments().length === 0" class="no-documents-message" style="margin-top: 8px;">
                    <i class="fa fa-folder-open text-muted"></i>
                    <small class="text-muted">Keine Dokumente vorhanden</small>
                  </div>
                </td>
              </tr>           
            </tbody>
        </table>
    </div>
  </div>

    
    
  <div *ngIf="this.calmod=='calendar'" class="">
  <!--Daten / TeamOrders-->
  <div class="scrollable-div" *ngIf="item && selectedSecMenuIndex == 1" >
  
    <!-- Status volle Breite (klickbar zum Ändern) -->
    <div class="event-status-row-full mb-2" *ngIf="item?.status || item?.status_id">
      <span 
        class="event-status-badge-full event-status-badge-clickable"
        [style.backgroundColor]="(item?.status?.color) || '#6c757d'"
        (click)="openStatusChangeModalForOrder()"
        title="Status ändern (klicken)">
        {{ item?.status?.label || item?.status?.name || 'Status ' + item?.status_id }}
      </span>
    </div>

    <table class="w-full">
      <tr style="border-bottom: 1px solid #000">
        <th colspan="5" class="text-center bg-gray-600 text-white">Termine</th>
      </tr>
      <tr style="border-bottom: 1px solid #000">
        <th>Typ</th>
        <th>Datum</th>
        <th>Uhrzeit</th>
        <th>Termin</th>
        <th>Team</th>
      </tr>
      <tr *ngFor="let to of item?.team_order"  (click)="gotoTeamOrder(to.start)" 
      class="cursor-pointer py-1"  
      style="border-bottom: 1px solid #ddd;">
    <td *ngIf="item?.team_order.length > 0" 
        class="text-center" 
        [ngStyle]="{'background-color': getBackgroundColor(to)}">
      <span *ngIf="item?.status || item?.status_id" 
            class="badge"
            [style.backgroundColor]="(item?.status?.color) || '#6c757d'"
            style="color: #fff;">{{ item?.status?.label || item?.status?.name || 'Status ' + item?.status_id }}</span>
    </td>
    <td>{{to.start | date: 'dd.MM.yyyy'}}</td>
    <td>{{to.start | date: 'HH:mm'}}</td>
    <td>{{to.team_order_type?.name}}</td>
    <td>{{to.team_base?.label}}</td>
  </tr>
  
<div *ngIf="item?.team_order.length == 0" class="w-full mx-auto">
  <span>Keine Termine</span>
</div>

    </table>

    <div style="max-height: 300px; overflow-y: auto; border: 1px solid #000;">
    <table class="w-full">
      <tr style="border-bottom: 1px solid #000">
        <th colspan="5" class="text-center bg-gray-600 text-white">Aktionen</th>
      </tr>
      <tr *ngIf="!actions" colspan="5" class="text-center">Keine Aktionen</tr>
      <ng-container *ngIf="actions">
      <tr style="border-bottom: 1px solid #000">
        <th>Datum</th>
        <th>Uhrzeit</th>
        <th>Bediener</th>
        <th>Aktion</th>
      </tr>
      
        <tr *ngFor="let action of actions.data?.slice().reverse()"  
            class="cursor-pointer py-1"  
            style="border-bottom: 1px solid #ddd;">
          <td>{{ action.created_at | date: 'dd.MM.yyyy' }}</td>
          <td>{{ action.created_at | date: 'HH:mm' }}</td>
          <td>{{ action.user }}</td>
          <td>{{ action.title }}</td>
        </tr>
      </ng-container>
  
    </table>
    </div>
    <table class="w-full">
      <tr style="border-bottom: 1px solid #000">
        <th colspan="5" class="text-center bg-gray-600 text-white">Notizen</th>
      </tr>
    </table>
    <app-note [module_id]=1 [module_item_id]="item.id" [view]=1></app-note>
    <!--table class="w-full">
      <tr style="border-bottom: 1px solid #000">
        <th colspan="8" class="text-center bg-gray-600 text-white">Notizen</th>
      </tr>
      <tr   class="cursor-pointer py-1"  
      style="border-bottom: 1px solid #ddd;">
        <th>Datum</th>
        <th>UZ</th>
        <th>User</th>
        <th colspan="5">Notiz</th>
      </tr>
    
        <tr *ngFor="let note of notes"  
            class="cursor-pointer py-1"  
            style="border-bottom: 1px solid #ddd;">
          <td>{{ note.created_at | date: 'dd.MM.yyyy' }}</td>
          <td>{{ note.created_at | date: 'HH:mm' }}</td>
          <td><span class="badge badge-danger">{{ note.user?.short}}</span></td>
          <td colspan="5">{{ note.description }}</td>
        </tr>
        
        
    
    </table-->
    
     
     
  </div>

  <!--div *ngIf="item && selectedSecMenuIndex == 1" style="height: 100%; width: 100%;">
    <a class="p-0.5 border-2 border-black" (click)="mapActionCenterOrder()">CO</a>
    <a class="p-0.5 border-2 border-black" (click)="mapActionSwitchViewMode()">SVM</a>
    <a class="p-0.5 border-2 border-black" (click)="mapActionSwitch3D2D()">VM</a>
    <a class="p-0.5 border-2 border-black" (click)="mapActionRotate()">Rotate</a>
  <agm-map style="height: calc(100%); width: 100%;" #map [latitude]="latitude" [longitude]="longitude" [zoom]="zoomLevel" [mapTypeId]="mapTypeId" [tilt]="tilt">
  <agm-direction *ngIf="selectedWaypoints?.length" 
    [origin]="getOrigin()"
    [destination]="getDestination()"
    [waypoints]="getWaypoints()"
    [optimizeWaypoints]="true">
</agm-direction>
<agm-marker *ngFor="let waypoint of selectedWaypoints"
 [latitude]="waypoint.lat"
 [longitude]="waypoint.lng"
 [iconUrl]="'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'"
 [iconSize]="{ width: 10, height: 10 }">
</agm-marker>
    <agm-circle 
      [latitude]="map_customer_branch?.lat"
      [longitude]="map_customer_branch?.lng"
      [radius]="40000"
      [strokeColor]="'#000000'"
      [strokeOpacity]="1"
      [strokeWeight]="1"
      [fillColor]="'#FFFF00'"
      [fillOpacity]="0.3"
      [editable]="false"
      [draggable]="false">
    </agm-circle>
    <agm-marker *ngIf="!item?.disposed" [latitude]="item?.lat" 
      [longitude]="item?.lng" 
      [iconUrl]="getSvgCircularMarker('A', 'DSP', 'black', 'white', 'black')"
      [iconSize]="{ width: 10, height: 10 }">
    </agm-marker>    
    <agm-marker *ngFor="let mto of map_team_orders"
      [latitude]="mto.order?.lat"
      [longitude]="mto.order?.lng"
      [iconUrl]="getSvgMarker(mto?.order.start | date: 'dd.MM.yy',mto?.order.order_number, mto.order.order_type.color, mto.order.order_type.color, 'white')"
      [iconSize]="{ width: 10, height: 10 }">
      <agm-info-window>
        <div>
          <p><span class="font-bold">Termin am:</span> <br><span class="p-0.5 bg-green-500 text-white">{{ mto?.order.start | date: 'dd.MM.yyyy' }}, {{ mto?.order.start | date: 'HH:mm' }} - {{ mto?.order.end | date: 'HH:mm' }}Uhr</span><br><span class="badge badge-secondary">{{mto.order.order_type?.label}} ({{mto.order.order_number}})</span><span class="ml-0.5 badge badge-secondary">{{ mto?.order.duration }}</span><br><span class="font-bold">{{ mto?.order.last_name }} {{ mto?.order.first_name }}</span><br>
            {{mto?.order.street}}, {{mto?.order.postal_code}} {{mto?.order.place}}</p>
        </div>
      </agm-info-window>
    </agm-marker>
    <agm-marker [latitude]="map_customer_branch?.lat" 
      [longitude]="map_customer_branch?.lng" 
      [iconUrl]="getSvgCircularMarker(map_customer_branch?.short,2, 'orange', 'white', 'black')"
      [iconSize]="{ width: 10, height: 10 }">
    </agm-marker> 


    <agm-marker *ngFor="let order of map_undisposed_orders"
      [latitude]="order?.lat"
      [longitude]="order?.lng"
      [iconUrl]="getMarker(order)">
      <agm-info-window>
        <div>
          <p><span class="badge badge-secondary">{{order.order_type?.label}} ({{order.order_number}})</span><span class="ml-0.5 badge badge-secondary">{{ order?.duration }}</span><br><span class="font-bold">{{ order?.last_name }} {{ order?.first_name }}</span><br>
            {{order?.street}}, {{order?.postal_code}} {{order?.place}}</p>
            <a class="btn btn-outline-secondary" (click)="navigateToOrder(order)">zum Auftrag</a>
        </div>
      </agm-info-window>
    </agm-marker>
  </agm-map>
</div-->
        

  <div class="scrollable-div" *ngIf="item && selectedSecMenuIndex == 2">

    
    <table *ngIf="selectedEvent" class="table table-striped rollcard">
    <tr>
      <td colspan="4" style="font-size: 14px !important" class="text-center bg-yellow-600 text-white">ID: {{selectedEvent?.team_base_id}} (soll Tour werden)</td>
    </tr>
    <tr>
      <td colspan="4" class="text-center bg-gray-800 text-white" style="font-size: 14px;">{{selectedEvent?.start | date: 'dd.MM.yyyy'}}</td>
    </tr>


    <tr>
      <td class="bg-gray-600 text-white font-bold" style="width: 15%">Anz. Aufträge:</td>
      <td class="w-1/4">{{selectedEvent.amount_orders}}</td>
      <td class="bg-gray-600 text-white font-bold" style="width: 15%">Auftragswert:</td>
      <td class="w-1/4">-</td>
    </tr>

    </table>

    <div class="scrollable-div" *ngIf="selectedEvent && selectedSecMenuIndex == 2" >
  
      <table class="w-full">
        <tr style="border-bottom: 1px solid #000">
          <th colspan="5" class="text-center bg-gray-600 text-white">Termine</th>
        </tr>
        <tr style="border-bottom: 1px solid #000">
          <th>Zeit</th>
          
          <th>Typ</th>
          <th>Kunde</th>
          <th>Betrag</th>
          <th>Dauer</th>
        </tr>
        <tr *ngFor="let to of selectedEvent?.teamOrders" 
        class="cursor-pointer py-1"  
        style="border-bottom: 1px solid #ddd;">
  
      <td class="padding: 5px; margin: 5px;">
        <div style="border: 2px dotted #666">
        {{to.start | date: 'HH:mm'}} Uhr<br>
        {{to.end | date: 'HH:mm'}} Uhr
        </div>
      </td>
      <td>{{to.order.order_type?.label}}<br><small *ngIf="(to.order?.status || to.order?.status_id)" 
        class="event-status-badge-full" 
        [style.backgroundColor]="(to.order?.status?.color) || '#6c757d'"
        style="display: inline-block; padding: 2px 8px; border-radius: 4px; color: #fff; font-size: 11px;">{{ to.order?.status?.label || to.order?.status?.name || 'Status ' + (to.order?.status_id) }}</small></td>
      <td>
        <strong>{{to.order?.first_name}} {{to.order?.last_name}}</strong><br>
        <small>{{to.order?.street}}, {{to.order?.postal_code}} {{to.order?.place}}</small><br>
        <small *ngIf="to.comment" style="background-color: #000 !important; padding: 0px 2px" class=" text-white">{{to.comment}}</small>
      </td>
      <td>
        <span *ngIf="to.order?.rev_total">{{to.order?.rev_total}} EUR</span>
        <span *ngIf="!to.order?.rev_total" alt="keine Angabe">k.A</span>
      </td>
      <td>
        {{helper.convertMinutesToHours(to.order?.duration) }}
      </td>
    </tr>
    
  <div *ngIf="item?.team_order.length == 0" class="w-full mx-auto">
    <span>Keine Termine</span>
  </div>
  
      </table>
  
       
    </div>



    
    

    
  </div>
  </div>
   
</div>
</div>

<!-- Modal für Status-Änderung -->
<div class="modal-overlay" *ngIf="showStatusChangeModal" (click)="closeStatusChangeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()" *ngIf="showStatusChangeModal">
    <div class="modal-header">
      <h3>Auftragsstatus ändern</h3>
      <button type="button" class="close" (click)="closeStatusChangeModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p *ngIf="statusChangeModalData">
        Auftrag <strong>#{{ statusChangeModalData.orderNumber }}</strong><br>
        <span class="text-muted">Aktuell: {{ statusChangeModalData.currentStatusLabel || '–' }}</span>
      </p>
      <div class="form-group" style="margin-top: 16px;">
        <label>Neuer Status:</label>
        <div class="status-select-list status-select-list-full">
          <button 
            type="button"
            class="btn btn-status-option btn-status-option-full"
            *ngFor="let s of statusList"
            (click)="changeOrderStatusFromModal(s.id)"
            [style.backgroundColor]="s.color || '#6c757d'"
            [class.selected]="statusChangeModalData?.currentStatusId === s.id">
            {{ s.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeStatusChangeModal()">Abbrechen</button>
    </div>
  </div>
</div>

<router-outlet  (deactivate)="onRouterOutletActivate($event)"></router-outlet>

    
